module.exports = __webpack_public_path__ + "img/step3.52cf745.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/step3.svg
// module id = ./assets/assistant/step3.svg
// module chunks = 10